import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import Button from 'components/generalUI/Button';
import LanguageSelector from 'components/generalUI/LanguageSelector';
import styles from './NavMenu.module.scss';

const NavMenu: FC = () => {
  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const hideDrawer = () => {
    setVisible(false);
  };

  return (
    <div className={styles.Menu}>
      <MenuOutlined onClick={showDrawer} className={styles.MenuOutlined} />
      <Drawer
        className={styles.Drawer}
        placement="left"
        onClose={hideDrawer}
        visible={visible}
        extra={
          <Button
            className={styles.PurchaseChangeButton}
            kind="secondary"
            shape="round"
            href="/purchaseChange"
            onClick={hideDrawer}
          >
            {t('navigation.navbar.purchaseChange')}
          </Button>
        }
      >
        <div className={styles.DrawerContainer}>
          <h2 className={styles.DrawerTitle}>
            <a className={styles.DrawerItem} href="/">
              {t('navigation.navbar.home')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a className={styles.DrawerItem} href="/somos">
              {t('navigation.navbar.aboutUs')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a
              className={styles.DrawerItem}
              href="https://mybakerlab.com/tricao/"
              onClick={hideDrawer}
            >
              {t('navigation.navbar.spaces')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a className={styles.DrawerItem} href="/#activities" onClick={hideDrawer}>
              {t('navigation.navbar.activities')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a
              className={styles.DrawerItem}
              href="/tricao-classroom"
              onClick={hideDrawer}
            >
              {t('navigation.navbar.programs')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a className={styles.DrawerItem} href="/corporateEvents" onClick={hideDrawer}>
              {t('navigation.navbar.corporateEvents')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a className={styles.DrawerItem} href="/giftCard">
              {t('navigation.navbar.giftCards')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a className={styles.DrawerItem} href="/faq">
              {t('navigation.navbar.faq')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a className={styles.DrawerItem} href="/newsPosts" onClick={hideDrawer}>
              {t('navigation.navbar.newsPosts')}
            </a>
          </h2>
          <h2 className={styles.DrawerTitle}>
            <a className={styles.DrawerItem} href="/contacto">
              {t('navigation.navbar.contact')}
            </a>
          </h2>
          <div className={styles.LanguageSelectorContainer}>
            <LanguageSelector />
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default NavMenu;
